module.exports = __webpack_public_path__ + "img/icon-home.38cec4c3.svg";